import icon from 'assets/img/icons/special-offers.svg';
import { BASE_URL } from 'consts/APIUrls';
import { useState } from 'react';
import CancelListingSuccess from './CancelListingSuccess';
import CancelListingStartIdentity from './CancelListingStartIdentity';
import CancelListingStartPrediction from './CancelListingStartPrediction';
import { createAPI } from 'services/api/api';
import PagePopopCloseButton from 'components/page-components/PagePopopCloseButton';
import CancelListingFail from './CancelListingFail';
import { useSoundPath } from 'hooks/useSoundPath';
import ModalWindow from 'components/ModalWindow';

const CancelListing = ({ id, cancelListingType, close }) => {

  const api = createAPI();
  const [step, setStep] = useState('start');
  const playSound = useSoundPath();

  const closeWindow = () => {
    close();
  }

  const delistSubmit = () => {
    playSound('main');
    api.post(`${BASE_URL}/marketplace_listing/${id}/cancel`)
      .then(() => setStep('success'))
      .catch((error) => {
        setStep(`fail-${error.status}`);
      })

  }

  return (
    <ModalWindow close={closeWindow}>
      <div className='modal-window__wrapper' onClick={(e) => e.stopPropagation()}>
        <PagePopopCloseButton close={close} />
        {
          step === 'start' && cancelListingType === 'default' ?
            <>
              <header className="modal-window__header">
                <img src={icon} className="modal-window__icon" alt="" />
                <h5 className="modal-window__title">Cancel listing</h5>
                <p className="modal-window__info">This card will no longer be listed for sale.</p>
              </header>
              <footer className="modal-window__footer">
                <button className="modal-window__footer-close" onClick={closeWindow}>Cancel</button>
                <button className="modal-window__footer-submit" onClick={delistSubmit}>Delist</button>
              </footer>
            </>
            :
            null
        }
        {(step === 'start' && cancelListingType === 'craft-identity') && <CancelListingStartIdentity closeWindow={closeWindow} delistSubmit={delistSubmit} />}

        {(step === 'start' && cancelListingType === 'craft-prediction') && <CancelListingStartPrediction closeWindow={closeWindow} delistSubmit={delistSubmit} />}

        {step === 'success' && <CancelListingSuccess closeWindow={closeWindow} />}
        {step.includes('fail') && <CancelListingFail step={step} closeWindow={closeWindow} />}
      </div>
    </ModalWindow>
  )
}

export default CancelListing;
